export default __webpack_public_path__ + "static/media/logoMini.1c2bf74e.svg";